import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import PhoneButton from "./PhoneButton";

const LOGO_URL = "/logo_transparent.png";

const NAV_LINKS = [
  { href: "#services", label: "Services" },
  { href: "#vehicule", label: "Véhicule" },
  { href: "#reservation", label: "Réservation" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled ? "nav-blur border-b border-white/[0.04] py-0" : "bg-transparent py-2"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-16">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <a href="/" data-testid="nav-logo" className="flex items-center group">
            <img
              src={LOGO_URL}
              alt="Warner VTC"
              className="h-14 sm:h-16 lg:h-20 w-auto"
            />
          </a>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-12">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace("é", "e")}`}
                className="relative text-[11px] tracking-[0.2em] uppercase text-white/40 hover:text-gold transition-colors duration-500 font-light py-2"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Phone CTA */}
          <PhoneButton
            className="hidden md:flex items-center gap-2 text-gold/70 text-[11px] tracking-[0.15em] hover:text-gold transition-colors duration-300"
          >
            <Phone size={12} strokeWidth={1.2} />
            <span>06 76 80 62 03</span>
          </PhoneButton>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white/60 hover:text-gold transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden nav-blur border-t border-white/[0.04]"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="text-[11px] tracking-[0.2em] uppercase text-white/50 hover:text-gold transition-colors"
              >
                {link.label}
              </a>
            ))}
            <div className="gold-line w-12 my-2" />
            <div className="flex flex-col gap-3">
              <a
                href="tel:0676806203"
                className="flex items-center gap-2 text-gold/70 text-[11px] tracking-[0.15em]"
              >
                <Phone size={12} strokeWidth={1.2} />
                <span>Appeler</span>
              </a>
              <a
                href="sms:0676806203"
                className="flex items-center gap-2 text-gold/70 text-[11px] tracking-[0.15em]"
              >
                <span className="w-3 h-3 flex items-center justify-center text-[9px]">SMS</span>
                <span>Envoyer un SMS</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
